<div class="p-3 bg-gray">
  <div class="row">
    <div class="d-flex justify-content-between">
      <div class="fs-16 fw-bold font-white mb-3">{{ menuID ? "Update" : "Add" }} Menu</div>
      <!-- <div [innerHtml]="SVG_ICONS.CLOSE_ICON() | sanitizer : 'html'" (click)="onClose()" tabindex="0" (keydown)="onClose()" class="cursor-pointer ms-auto"></div> -->
    </div>
    <div class="border-bottom mb-2 mt-2"></div>
    @if(ErrorMsg.length > 0){
    <div AsteriskMessage [messageList]="ErrorMsg"></div>
    }

    <div class="col-md-6 col-12 mt-2">
      <label for="TrainerLastName" class="fs-14 fw-normal font-white">Menu Name <span class="text-danger">*</span></label>
      <input class="form-control bg-form-control border-0 font-white" onlyCharacter maxlength="45" [(ngModel)]="menuList.MenuName" name="MenuName" placeholder="Menu Name" />
    </div>
    <div class="col-md-6 col-12 mt-2">
      <label for="TrainerLastName" class="fs-14 fw-normal font-white">Menu Path <span class="text-danger">*</span></label>
      <input class="form-control bg-form-control border-0 font-white" maxlength="45" [(ngModel)]="menuList.RouterPath" name="MenuPath" placeholder="Menu Path" />
    </div>
    <div class="col-md-6 col-12 mt-2">
      <label for="TrainerLastName" class="fs-14 fw-normal font-white">Order</label>
      <input class="form-control bg-form-control border-0 font-white" onlyNumber maxlength="3" [(ngModel)]="menuList.iorder" name="Order" placeholder="Order" />
    </div>
    <div class="col-md-6 col-12 mt-2">
      <label for="TrainerLastName" class="fs-14 fw-normal font-white">Default SVG</label>
      <input class="form-control bg-form-control border-0 font-white" [(ngModel)]="menuList.svg_default" name="DefaultSVG" placeholder="Default SVG" />
    </div>
    <div class="d-flex justify-content-end mt-5">
      <button class="close-btn me-2 px-4 py-1" (click)="onClose()">Close</button>
      <button class="add-btn px-4 py-1" (click)="onSubmit()">{{ menuID ? "Update" : "Add" }}</button>
    </div>
  </div>
</div>
